import { auth } from "../firebase";
export const createRecipe = async (newRecipe, imageFile) => {
    let imageUrl = null;
    let imagePath = null;


    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const token = await auth.currentUser.getIdToken();

    if (imageFile) {
        const uploadResult = await uploadImage(imageFile, token);
        imageUrl = uploadResult.imageUrl;
        imagePath = uploadResult.fileName;
    }

    const response = await fetch(`${BACKEND_URL}/api/recipe/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            ...newRecipe,
            imageUrl,
            imagePath
        })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Błąd zapisu');
    }
    return await response.json();
}

export const remove = async (recipeId, userId)=> {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const token = await auth.currentUser.getIdToken();
    const response = await fetch(`${BACKEND_URL}/api/recipe/remove/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({recipeId: recipeId, userId: userId })
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Błąd usuwania');
    }
    return await response.json();
}

export const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const token = await auth.currentUser.getIdToken();
    const response = await fetch(`${BACKEND_URL}/api/upload/recipe-image`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    return response.json(); // { imageUrl, fileName }
};

export const editRecipe = async (recipeId, updatedRecipe) => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const token = await auth.currentUser.getIdToken();

    const response = await fetch(`${BACKEND_URL}/api/recipe/edit`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id: recipeId, ...updatedRecipe })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Błąd edycji');
    }
    return await response.json();
};

export const editRecipeAdmin = async (recipeId, updatedRecipe) => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const token = await auth.currentUser.getIdToken();

    const response = await fetch(`${BACKEND_URL}/api/recipe/edit-admin`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id: recipeId, ...updatedRecipe })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Błąd edycji');
    }
    return await response.json();
};